import { render } from "./TheOperatingCenter.vue?vue&type=template&id=70a0ec61&scoped=true"
import script from "./TheOperatingCenter.vue?vue&type=script&lang=js"
export * from "./TheOperatingCenter.vue?vue&type=script&lang=js"

import "./TheOperatingCenter.vue?vue&type=style&index=0&id=70a0ec61&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a0ec61"]])

export default __exports__